import React from "react";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";

import SwatchDisabled from "core/ReusableIcons/Close";
import BodyText from "core/BodyText";
import appColors from "core/colors";
import Tooltip from "core/Tooltip";

import { SHAPES } from "icons/IconEditor/constants";

import { ContainerGrid, Swatch, SwatchBodyText } from "./styles";

import { normalizeHexCode } from "icons/IconEditor/helpers";

const Swatches = ({
    colors,
    onSwatchClick,
    title,
    swatchTestId,
    forBackground,
    currentShape
}) => {
    const normalizeColors = colors.map(color => {
        color = normalizeHexCode({ hexCode: color });

        if (!color) {
            return "";
        } else {
            return color;
        }
    });

    return (
        <ContainerGrid container alignItems="center">
            <SwatchBodyText
                type="p"
                size="xs"
                copyColor={appColors.secondary.orca}
            >
                {title}
            </SwatchBodyText>

            <Grid container>
                {normalizeColors.map((color, idx) => {
                    const swatchIsDisabled =
                        forBackground &&
                        !color &&
                        currentShape !== SHAPES.SQUARE;

                    return (
                        <Swatch
                            type="button"
                            aria-label={`Hex Code ${color}`}
                            key={idx}
                            color={color}
                            onClick={() => onSwatchClick(color)}
                            data-testid={swatchTestId}
                            disabled={swatchIsDisabled}
                        >
                            {swatchIsDisabled && (
                                <Tooltip
                                    zIndex={9999999}
                                    message="Transparent is only available for the square shape."
                                >
                                    <SwatchDisabled
                                        fillColor={appColors.secondary.oolong}
                                        size={{ width: 12, height: 12 }}
                                    />
                                </Tooltip>
                            )}
                        </Swatch>
                    );
                })}
            </Grid>
        </ContainerGrid>
    );
};

Swatches.propTypes = {
    colors: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    title: PropTypes.string.isRequired,
    onSwatchClick: PropTypes.func.isRequired,
    forBackground: PropTypes.bool,
    currentShape: PropTypes.oneOf(Object.values(SHAPES))
};

export default Swatches;
